"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.portal_detector = exports.UserError = exports.experience = exports.generations = exports.Command = exports.Behavior = exports.supportedVersions = void 0;
exports.createMCServer = createMCServer;
const minecraft_protocol_1 = require("minecraft-protocol");
const version_1 = require("./lib/version");
Object.defineProperty(exports, "supportedVersions", { enumerable: true, get: function () { return version_1.supportedVersions; } });
const command_1 = __importDefault(require("./lib/command"));
const builtinModules = __importStar(require("./lib/modules"));
const events_1 = require("events");
require("./types"); // include Server declarations from all modules
require("./modules");
// #region RUNTIME PREPARE
if (typeof process !== 'undefined' && !process.browser && process.platform !== 'browser' && parseInt(process.versions.node.split('.')[0]) < 18) {
    console.error('[\x1b[31mCRITICAL\x1b[0m] Node.JS 18 or newer is required');
    console.error('[\x1b[31mCRITICAL\x1b[0m] You can download the new version from https://nodejs.org/');
    console.error(`[\x1b[31mCRITICAL\x1b[0m] Your current Node.JS version is: ${process.versions.node}`);
    process.exit(1);
}
require('emit-then').register();
if (process.env.NODE_ENV === 'dev') {
    require('longjohn');
}
function createMCServer(options) {
    const mcServer = new MCServer();
    mcServer.connect({
        // defaults
        "max-entities": 100,
        ...options
    });
    return mcServer;
}
class MCServer extends events_1.EventEmitter {
    pluginsReady = false;
    abortController = new AbortController();
    constructor() {
        super();
    }
    connect(options) {
        if (globalThis.server) {
            // don't call quit so we don't disconnect players
            globalThis.server.cleanupFunctions.forEach(fn => fn());
        }
        const server = this;
        server.abortSignal = this.abortController.signal;
        server.cleanupFunctions = [
            () => this.abortController.abort()
        ];
        const mcData = require('minecraft-data')(options.version);
        server.mcData = mcData;
        if (mcData === null)
            throw new Error(`Version ${options.version} is not supported as it doesn't have the data.`);
        const version = mcData.version;
        if (!version_1.supportedVersions.some(v => v.includes(version.majorVersion))) {
            console.warn(`Version ${version.minecraftVersion} is not supported.`);
        }
        server.supportFeature = feature => {
            if (feature === 'theFlattening')
                feature = 'blockStateId';
            if (feature === 'dimensionDataIsAvailable')
                return +options.version.split('.')[1] >= 16;
            return mcData.supportFeature(feature);
        };
        server.commands = new command_1.default({});
        // pass version, motd, port, max-players, online-mode
        const oldServer = options.oldServerData;
        server._server = oldServer?._server ?? (0, minecraft_protocol_1.createServer)(options);
        if (oldServer) {
            server.players = oldServer.players;
            for (const [key, value] of Object.entries(oldServer.oldData)) {
                server[key] = value;
            }
        }
        const patchServer = (server) => {
            server.oldAddListener ??= server.on.bind(server);
            server.patchedAddListener = (name, ...args) => {
                server.oldAddListener(name, ...args);
                server.cleanupFunctions.push(() => server.removeListener(name, ...args));
            };
            server.on = server.patchedAddListener;
            server.addListener = server.patchedAddListener;
        };
        patchServer(server);
        const promises = [];
        server.plugins = builtinModules.builtinPlugins;
        for (const plugin of Object.values(server.plugins)) {
            promises.push(plugin.server?.(server, options));
        }
        Promise.allSettled(promises).then((values) => {
            for (const rejected of values.filter(value => value.status === 'rejected')) {
                server._server.emit('error', rejected.reason);
            }
            // handle successful results of promises
            for (const value of values.filter(value => value.status === 'fulfilled')) {
                // todo remove when updated to typescript 5.5
                //@ts-ignore
                if (value.value) {
                    //@ts-ignore
                    server.cleanupFunctions.push(value.value);
                }
            }
            server.emit('pluginsReady');
            server.pluginsReady = true;
        });
        if (options.logging === true)
            server.createLog();
        server._server.on('error', error => {
            server.emit('error', error);
        });
        server._server.on('listening', () => {
            server.emit('listening', server._server.socketServer.address().port);
        });
        server.emit('asap');
    }
}
exports.Behavior = __importStar(require("./lib/behavior"));
exports.Command = __importStar(require("./lib/command"));
var generations_1 = require("./lib/generations");
Object.defineProperty(exports, "generations", { enumerable: true, get: function () { return __importDefault(generations_1).default; } });
exports.experience = __importStar(require("./lib/experience"));
exports.UserError = __importStar(require("./lib/user_error"));
var portal_detector_1 = require("./lib/portal_detector");
Object.defineProperty(exports, "portal_detector", { enumerable: true, get: function () { return __importDefault(portal_detector_1).default; } });
